<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("bc_coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button size="md" type="neutral" @click="handleCreate()">{{ $t("new") }}</base-button>


                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">
                            <div class="col-lg-3">
                                <base-input v-model="searchQuery" prepend-icon="fas fa-search"
                                    :placeholder="$t('search')">
                                </base-input>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <el-table-column :label="$t('name')">
                                <div slot-scope="{ row }">
                                    {{ row.name }}
                                </div>
                            </el-table-column>

                            <el-table-column align="right" :label="$t('actions')">
                                <div slot-scope="{ $index, row }" class="d-flex">
                                    <base-button @click.native="
                                        handleDetail($index, row)
                                        " class="edit" type="warning" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>
                                    <base-button @click.native="
                                        handleDelete($index, row)
                                        " class="remove btn-link text-white" type="danger" size="sm" icon>
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <div class="row">
                    <div class="col-md-10">
                        <base-input :label="$t('name')" v-model="params.name">
                        </base-input>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-10">
                        <base-input :label="$t('coupon_prefix')" v-model="params.prefix">
                        </base-input>
                    </div>
                </div>



                <div class="row">
                    <div class="col-md-6">
                        <base-input :label="$t('coupon_start')" v-model="params.running_start">
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <base-input :label="$t('coupon_end')" v-model="params.running_end">
                        </base-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <base-input :label="$t('valid_from')">
                            <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                :config="{ allowInput: true }" :placeholder="$t('time_to')"
                                class="form-control datepicker" v-model="params.valid_from">
                            </flat-picker>
                        </base-input>
                    </div>

                    <div class="col-md-6">
                        <base-input :label="$t('valid_to')">
                            <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                :config="{ allowInput: true }" :placeholder="$t('time_to')"
                                class="form-control datepicker" v-model="params.valid_to">
                            </flat-picker>
                        </base-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2">
                        <base-input>
                            <el-select v-model="params.bo_user_id" :placeholder="$t('coupon_discount_type')" filterable>
                                <el-option v-for="option in DiscountTypeTable" :key="option.id" :label="option.name"
                                    :value="option">
                                </el-option>
                            </el-select>
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-input :label="$t('coupon_amount_mininum')" v-model="params.discount_value">
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-input :label="$t('coupon_discount_value')" v-model="params.amount_minimum">
                        </base-input>
                    </div>
                </div>

                <div class="row" v-for="(option, index) in params.conditions" :key="index">
                    <div class="col-md-10">
                        {{ option.name }}
                    </div>

                    <div class="col-md-2">
                        <base-button size="sm" @click="handleRemoveCondition(index)" type="danger">
                            <i class="fa fa-trash"></i></base-button>

                    </div>
                </div>
            </form>

            <template slot="footer">
                <button type="submit" class="btn btn-md btn-primary" @click="handleUpdate()" disabled
                    v-if="isCreateMode">
                    {{ $t("save") }}
                </button>
                <button type="submit" class="btn btn-md btn-primary" @click="handleUpdate()" v-if="isCreateMode">
                    {{ $t("save") }}
                </button>
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showModal = false">
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from "xlsx";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getData",
            getCurrentPage: "Coupon/getCurrentPage",
        }),
    },
    data() {
        return {
            propsToSearch: ["name"],
            selectedRows: [],
            showModal: false,
            isCreateMode: false,
            params: {
                name: "",
                prefix: "",
                running_start: 0,
                running_end: 0,
                running_digit: 4,
                valid_start: "",
                valid_end: "",
                discount_type: 1,
                discount_value: "",
                amount_minimum: "",
                conditions: []
            },
        };
    },
    mounted() {
        this.listData()
    },
    methods: {
        ...mapActions({
            createData: "Coupon/createData",
            updateData: "Coupon/updateData",
            deleteData: "Coupon/deleteData",
            listData: "Coupon/listData",
            listDataDetail: "Coupon/listDataDetail",
            setCurrentPage: "Coupon/setCurrentPage",
        }),

        handleCreate() {
            this.isCreateMode = true
            this.params.name = ""
            this.params.prefix = ""
            this.params.running_start = 0
            this.params.running_end = 9999

            // set start to current date
            this.params.valid_start =
                this.params.valid_end =

                this.showModal = true;
        },
        addCondition() {
            // Validate condition
            // 1. check discount > 0
            // 2. check amount minimum > 0
            // 3. check discount , amount minimum is duplicate
            let condition = {
                discount_value: this.params.discount_value,
                discount_type: this.params.discount_type,
                amount_minimum: this.params.amount_minimum,
            }

            this.params.conditions.push(condition)
        },
        removeCondition(index) {
            this.params.conditions.splice(index, 1);
        },
        handleUpdate() {

        },
        handleDetail(index, row) {
            this.isCreateMode = false

            this.showModal = true

        },
        handleDelete(index, row) {
            this.setCurrentPage(this.pagination.currentPage);
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
                            this.pagination.currentPage = this.getCurrentPage;
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
        GetProductUrl(filename) {
            return (
                process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
            );
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
